<mat-sidenav-container [class.animation]="collapsed()">

  <mat-sidenav
    opened
    mode="side"
    disableClose
    [autoFocus]="false"
    [style.width]="sidNavWidth()">
    <div class="header">
      <app-language-selector
        [class.hidden]="collapsed()"
        class="language-selector"
      />

      <button mat-icon-button (click)="collapsed.set(!collapsed())">
        <mat-icon [class.rotated]="collapsed()">menu</mat-icon>
      </button>
    </div>

    <mat-nav-list
      [class.height]="collapsed()"
      [class.master]="role === 'Master'"
    >
      @for (item of displayMenuItems; track item.name) {
        <app-menu-item
          [item]="item"
          [collapsed]="collapsed()"
        ></app-menu-item>
      }
    </mat-nav-list>

    @if (role !== 'Master') {
      <div class="user-info" [class.hidden]="collapsed()">
        <div class="info">
          <span>{{ role }}</span>
          <span><strong>{{ name }}</strong></span>
        </div>

        <app-select
          [label]="'HEADER.ENTERPRISE' | translate"
          [placeholder]="'HEADER.ENTERPRISE_PLACEHOLDER' | translate"
          [control]="form.get('enterprise')"
          [items]="enterpriseOptions"
          (valueChange)="onChangeEnterprise($event)"
          darkMode
          hiddenClearButton
        ></app-select>
      </div>
    }

    <div class="footer">
      <img
        src="assets/images/logo-sidebar.png"
        alt="logo"
        class="logo"
        [class.hidden]="collapsed()"
      />

      <img
        src="assets/images/logo-icon.png"
        alt="logo"
        class="logo-icon"
        [class.hidden]="!collapsed()"
      />
    </div>
  </mat-sidenav>

  <mat-sidenav-content [style.margin-left]="sidNavWidth()">
    <div class="side-nav-content">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>

@if (loading()) {
  <div class="overlay">
    <div class="overlay-content">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </div>
}
